const BaseView = require('components-framework/view/base.view');

module.exports = BaseView.extend({
    events: {
        'tap .toggle_more_info': 'onToggleMoreInfo',
    },
    initialize() {
        this.listenTo(this.model, 'change', this.render);
        this.render();
    },
    onToggleMoreInfo(evt) {
        this.model.toggleMoreInfo();
        evt.stopPropagation();
    },
    render() {
        this.$el.html(this.templates.main({
            templates: this.templates,
            keys: this.keys,
            model: this.model.toJSON(),
            options: this.options,
        }));
    },
});
